<!-- eslint-disable max-len -->
<template>
  <div class="main-content flex-1 bg-gray-100 mt-20 md:mt-20 pb-50 md:pb-5 overflow-y-scroll">

    <div class="flex flex-wrap">
      <div class="w-full p-3">
        <div
          class="bg-gray-400 border-b-2 border-gray-500 rounded-tl-lg rounded-tr-lg p-2"
        >
          <h5 class="font-bold uppercase text-gray-600">Transaction Report </h5>
        </div>
        <div class="overflow-y-auto">
          <div style="margin-bottom: 10px">
            <el-row class="px-5 py-2 " >
              <el-col :span="9" class="flex flex-row" >
                <el-row class="px-5 py-2" >
                  <el-col :span="8" class="flex flex-row w-50" >Filter Month</el-col>
                  <el-col :span="8" class="flex flex-row mr-1" >
                    <vue-monthly-picker
                      v-model="selectedMonth"
                      :monthLabels="monthLabels"
                      :selectedBackgroundColor="'#1a202c'"
                      :clearOption="false"
                      :max="maxMonth"
                      :min="minMonth"
                      @selected="onChangeDate"
                    >
                    </vue-monthly-picker>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="5" class="flex flex-row" v-if="paymentDate!==''">
                <div class="bg-transparent w-full p-2">
                  <div class="card cursor-pointer border border-gray-400 rounded-lg">
                    <div class="m-3">
                      <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Payment Date</h2>
                      <div class="text-xl text-center text-black font-bold">{{paymentDate}}</div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="5" class="flex flex-row" v-if="artistTotalPayout!=0" >
                <div class="bg-transparent w-full p-2">
                  <div class="card cursor-pointer border border-gray-400 rounded-lg">
                    <div class="m-3">
                      <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Total Payout</h2>
                      <div class="text-4xl text-center text-black font-bold">${{parseFloat(toDollar(artistTotalPayout)).toFixed(2)}}</div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="artistTotalPayout!=0 && paymentDate!=='' ?5:15" class="flex flex-row justify-end" >
                <div class="bg-transparent w-full p-2">
                  <div class="card cursor-pointer border border-gray-400 rounded-lg">
                    <div class="m-3">
                      <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Earning</h2>
                      <div class="text-4xl text-center text-black font-bold">${{parseFloat(toDollar(artistEarning)).toFixed(2)}}</div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>

          <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
          </data-tables-server>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import VueMonthlyPicker from 'vue-monthly-picker';
import moment from 'moment';

const displayingItems = 50;

export default {
  name: 'ReportPage',
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      selectedMonth: moment(),
      maxMonth: moment(),
      minMonth: moment().subtract(3, 'months'),
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'product',
        label: 'Product',
      }, {
        prop: 'date',
        label: 'Date',
      }, {
        prop: 'amount',
        label: 'Amount',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        sortby: 'transaction.id',
        sortorder: 'desc',
        month: moment().format('YYYY-MM'),
      },
      paymentDate: '',
      monthLabels: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListReport(this.filter);
    await this.requestArtistEarning(this.filter);
    // this.refineData();
  },
  computed: {
    ...mapGetters('TransactionModule', ['listReport', 'artistEarning', 'artistTotalPayout', 'artistDateReceived']),
  },
  watch: {
    listReport: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listReport.data !== undefined) {
          this.data = this.listReport.data.data.map(report => ({ ...report, amount: `$${parseFloat(this.toDollar(report.artist_cut)).toFixed(2)}`, date: moment(report.created_at).format('YYYY-MM-DD HH:mm:ss') }));
          this.total = this.listReport.data.total;
        }
      },
    },
    artistDateReceived: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val !== '') {
          if (this.utc_offset < 0) {
            this.paymentDate = moment(val).subtract(Math.abs(this.utc_offset), 'hour').format('YYYY-MM-DD HH:mm:ss');
          } else {
            this.paymentDate = moment(val).add(this.utc_offset, 'hour').format('YYYY-MM-DD HH:mm:ss');
          }
        } else {
          this.paymentDate = '';
        }
      },
    },
  },
  methods: {
    ...mapActions('TransactionModule', ['requestListReport', 'requestArtistEarning']),
    async search() {
      await this.requestListReport(this.filter);
      await this.requestArtistEarning(this.filter);
      // this.refineData();
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
        month: moment().format('YYYY-MM'),
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'transaction.id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListReport(this.filter);
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        month: moment(res).format('YYYY-MM'),
      };
      await this.search();
    },
  },
  components: {
    VueCustomTooltip,
    VueMonthlyPicker,
  },
};
</script>
<style scoped>
  .z-1000{
    z-index: 1000;
  }
  .mx-400{
    max-height: 50%;
    height: 50vh;
  }
</style>



// WEBPACK FOOTER //
// src/views/Report.vue